<template>
<div>
  <querytitle>
    <template slot="queryleft">
      <div style="padding-right: 20px">
        <span style="color: red; font-size: 15px; font-weight: bold">{{SFT.TNAME}}</span> <el-tag size="small" type="danger">{{SS.SSSTATE}}</el-tag>
      </div>
      <div style="text-align: left">
        <span style="color: #000"></span>
        <span>{{ SFT.TDESC }}</span>
      </div>
    </template>
    <template slot="queryright">
      <div v-if="SS.SSSTATE=='未完成' || SS.SSSTATE=='已驳回'" >
        <filedialogbutton :par="pars" :TNAME="''" :okupload="getlist"></filedialogbutton>
      </div>
      <el-button-group>
        <el-button type="success" size="small" @click="drawerweek=true">查看周志</el-button>
        <el-button type="info" size="small" @click="drawer=true">操作日志</el-button>
      </el-button-group>  
    </template>
  </querytitle>
  <div :style="'height:' + hh + 'px;'" class="send">
    <div style="width:100%;border:1px solid #EBEEF5;">
      <el-tabs type="card" tab-position="left" :style="'height:'+hh2+'px;padding:0px;'">
        <el-tab-pane :label="pitem.ZJCLASS" v-for="(pitem,index) in itemlist" :key="index" :style="'height:' + hh2 + 'px;overflow:auto;'">
          <fileview :item="citem" v-for="(citem,cindex) in pitem.children" :key="cindex" :hh="hh-5">
            <template v-if="pitem.ZJCLASS!='任务书'" slot="editbar">
              <div v-if="SS.SSSTATE=='未完成' || SS.SSSTATE=='已驳回'" style="display:flex;">
                <el-button type="text" @click="edit(citem)" style="color: green" icon="el-icon-edit">修改文件名称</el-button>
                <el-button type="text" @click="del(citem, cindex)" style="color: red"  :disabled="citem.paperguid && !citem.paperviewurl ? true : false" icon="el-icon-close" v-if="SS.SSSTATE=='未完成' || SS.SSSTATE=='已驳回'" >删除当前文件</el-button>

                <el-dropdown style="color: #790404;font-weight: bold;font-size: 16px;margin: 10px;" @command="headerCommand"  v-if="CU.cu.cc == '1' && CU.cu.zjcc.includes(pitem.ZJCLASS)">
                  <span style="cursor: pointer;">
                    <i class="el-icon-search"></i>查重检测<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="wp">
                      <el-button type="text" v-if="getfinish(citem,'wp')" @click="ccstate(citem,cindex,'wp')" style="color: #790404;font-weight: bold;font-size: 16px;" icon="el-icon-loading">维普检测中...</el-button>
                      <el-button type="text" v-else @click="ccgo(citem,cindex,'wp')" style="color:#790404;font-weight: bold;font-size: 16px;" icon="el-icon-search">维普查重</el-button>
                    </el-dropdown-item>
                    <!-- <el-dropdown-item command="xn">
                      <el-button type="text" v-if="getfinish(citem,'xn')" @click="ccstate(citem,cindex,'xn')" style="color: #790404;font-weight: bold;font-size: 16px;" icon="el-icon-loading">校内检测中...</el-button>
                      <el-button type="text" v-else @click="ccgo(citem,cindex,'xn')" style="color:#790404;font-weight: bold;font-size: 16px;" icon="el-icon-search">校内查重</el-button>
                    </el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>

                <!-- <div v-if="CU.cu.cc == '1' && CU.cu.zjcc.includes(pitem.ZJCLASS)">
                  <el-button type="text" v-if="getfinish(citem)" @click="ccstate(citem,cindex)" style="color: gray;" icon="el-icon-loading">查重检测中...</el-button>
                  <el-button type="text" v-else @click="ccgo(citem,cindex)" style="color:goldenrod" icon="el-icon-search">查重检测</el-button>
                </div> -->
              </div>
            </template> 
          </fileview>
        </el-tab-pane>
        <!-- <el-tab-pane label="查重报告" v-if="SS.paperviewurl"  :style="'height:' + hh2 + 'px;overflow:auto;'">
          <iframe :src="SS.paperviewurl" :style="'height:'+hh3+'px;width:100%;'"></iframe>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
  <el-drawer title="操作日志" :visible.sync="drawer" direction="rtl" :with-header="false" size="460px">
    <div style="padding:3px;display: flex;flex-direction:row;align-items: center;justify-content:space-between;">
      <h4>操作日志</h4>
      <el-checkbox-group v-model="radio" size="mini" @change="changecheckbox()">
          <el-checkbox label="更新文件">更新文件</el-checkbox>
          <el-checkbox label="审阅成果">审阅</el-checkbox>
          <el-checkbox label="普查成果">普查</el-checkbox>
          <el-checkbox label="抽查成果">抽查</el-checkbox>
        </el-checkbox-group>
    </div>
    
    <el-timeline>
      <el-timeline-item  :timestamp="item.CDATE+'>'+item.UNAME" placement="top" v-for="(item,index) in loglistact" :key="index" >
        <el-card shadow="hover">
          <div><span style="color:red;">{{item.LOGTYPE}}</span><span>{{item.ZJCLASS}}</span></div>
          <div style="padding:3px;" v-html="item.LOGCONTENT.replace(/\n/g,'<br />')"></div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </el-drawer>
  <el-drawer title="周志" :visible.sync="drawerweek" direction="rtl" :with-header="false">
    <div style="padding:0px 0px 0px 20px;display: flex;flex-direction:row;align-items: center;justify-content:space-between;"><h4>周志</h4><div><el-button type="danger" size="small" @click="addweek()" v-if="SS.SSSTATE=='未完成' || SS.SSSTATE=='已驳回'">新增周志</el-button></div></div>
    <el-timeline>
      <el-timeline-item placement="top" v-for="(item,index) in weekloglist" :key="index" >
        <el-card shadow="hover">
          <div style="padding:3px;display: flex;flex-direction:row;align-items: center;justify-content:space-between;">
            <div>{{item.CDATE}}:{{item.LOGTYPE}}</div>
            <div>
              <el-button-group v-if="SS.SSSTATE=='未完成' || SS.SSSTATE=='已驳回'" >
                <el-button style="float: right; padding: 3px 0;color:red" size="mini" type="text" icon="el-icon-close" @click="delweek(item,index)">删除</el-button>
                <el-button style="float: right; padding: 3px 0;color:green" size="mini" type="text" icon="el-icon-edit" @click="editweek(item,index)">编辑</el-button>
              </el-button-group>              
            </div>
          </div>
          <div style="padding:3px;" v-html="item.LOGCONTENT.replace(/\n/g,'<br />')"></div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </el-drawer>
  <sftsumit :SFT="SFT" :chkdata="chkdata"></sftsumit>
  <el-dialog title="编辑周志" :visible="dialogFormWeekVisible" :show-close="false" width="660px">
    <el-form label-width="100px">
      <el-form-item label="时间周期：">
        <el-input v-model="weeklog.LOGTYPE" placeholder="第几周"></el-input>
      </el-form-item>
      <el-form-item label="周志内容：">
        <el-input type="textarea" v-model="weeklog.LOGCONTENT" @input="inputmethod()"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormWeekVisible=false">取 消</el-button>
      <el-button type="primary" @click="postweek()">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="查重检测" :visible.sync="dialogFormWeekVisible1" width="500px">
    <div>
      <div v-if="cc<ccmax">
        <p>系统只给每位学生提供<span style="color:red;font-weight: bold;">{{ccmax}}</span>次查重额度，当前已经使用<span style="color:red;font-weight: bold;">{{cc}}</span>次!</p>
        <p>确定继续提交检测吗？</p>
      </div>
      <div v-else>
        每位学生系统只提供{{ccmax}}次查重额度，当前已经超出额度，请点击此链接<a :href="ccgr" target="_blank">自主检测</a>。
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <querytitle>
        <template slot="queryleft">
          <el-link :href="ccgr" target="_blank" type="success" v-if="cc<ccmax">先自主检测</el-link>
        </template>
        <template slot="queryright">
          <el-button @click="dialogFormWeekVisible1=false">取 消</el-button>
          <el-button type="primary" @click="ccsummit()"  v-if="cc<ccmax">确 定</el-button>
        </template>
      </querytitle>
      
    </div>
  </el-dialog>
</div>
</template>

<script>
//撰写设计成果
import querytitle from "@/components/querytitle";
import sftsumit from "@/components/sftsumit";
import fileview from '@/components/fileview'
import filedialogbutton from '@/components/filedialogbutton'
import internal from "assert";
export default {
  components: {
    querytitle,
    sftsumit,
    fileview,
    filedialogbutton,
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.params.SFT != from.params.SFT) {
        //pid不为空才请求数据
        this.init();
      }
    },
  },
  data() {
    return {
      hh: 500,
      hh2: 450,
      hh3:446,
      itemlist: [],
      SFT: null,
      loglist: [],
      loglistact:[],
      weekloglist:[],
      SS: {}, //当前学生信息
      // zjclass: '毕业设计作品',
      // dialogFormVisible: false,
      dialogFormWeekVisible: false,
      weeklog:{},
      weeklogIndex:0,
      addflag:false,
      drawer:false,
      drawerweek:false,
      pars:{objname:'zj_works',ZJS:['毕业设计说明书','毕业设计作品','老师指导记录','查重报告','其它'],SID:'',SSID:''},
      radio:["更新文件","审阅成果","普查成果","抽查成果"],
      dialogFormWeekVisible1: false,
      itemedit:{},
      itemeditindex:0,
      ccgr:'',
      ccmax:2,
      cc:2,
    }
  },
  created() {
    this.init();
  },
  methods: {
    getfinish(item,ccfs){//是否正在检测
      if(ccfs == 'wp' && item.paperguid){
        if(!item.paperviewurl)
          return true;
        else
          return false;
      }
      if(ccfs == 'xn' && item.dataid){
        if(!item.paperviewurlxn){
            return true;
          }
          else{
            return false
          }
      }
      return false;
    },
    init() {
      //this.ccmax = parseInt(this.CU.cu.ccmax)
      this.SFT = this.GetSFT();
      this.hh = document.documentElement.clientHeight - 245;
      this.hh2 = this.hh-10;
      this.hh3 = this.hh-30;
      this.getzjs();
      this.getlist();
      this.getlogs();
      this.getweeklogs();
      this.getstudent();
    },
    changecheckbox(){
      let that =this
      that.loglistact =[]
      that.loglist.forEach((item,index)=>{
         if(that.radio.indexOf(item.LOGTYPE)>=0){
          that.loglistact.push(item);
         }
      })
    },
    getzjs(){
      let that = this
      that.pars.SID = that.CU.cu.sid
      that.pars.SSID = that.CU.cu.uid
      that.GetData('GetZJS',{SID:that.CU.cu.sid},function(res){
        that.pars.ZJS = res.data.ZJS;
      },function(err){

      })
    },
    inputmethod() {
      this.$forceUpdate()
    },

    edit(par) {
      const that = this;
      this.$prompt("文件名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /'*/,
          inputPlaceholder: "请输入文件名称",
          inputValue: par.FILENAME,
          inputErrorMessage: "请输入文件名称",
        })
        .then(({
          value
        }) => {
          let pars = {
            objname: "zj_works",
            model: {
              ZWID: par.ZWID,
              FILENAME: value
            },
          };
          that.PostData(
            "Common/EDIT",
            pars,
            function (res) {
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              par.FILENAME = value;
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    del(item, index) {
      const that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let pars = {
            objname: "zj_works",
            model: {
              ZWID: item.ZWID,
              FILEPATH: item.FILEPATH
            },
          };
          that.PostData(
            "Common/DEL",
            pars,
            function (res) {
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              that.getlist()
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    ccgo(item, index,ccfs) {
      let that = this
      if(!that.SS.SSTITLE){
        that.$alert('选题为空，无法继续！', {
          title: "错误"
        });
        return;
      }
      that.itemedit = item;
      that.itemeditindex = index;
      if(ccfs == 'wp'){
        that.GetData('CCAutoLogin', { zwid: item.ZWID }, function (res) {
          console.log(res)
          that.ccgr = res.data.data;
          that.cc = res.data.cc*1;
          that.ccmax = res.data.ccmax*1;
          that.dialogFormWeekVisible1 = true;
        }, function (err) {
          that.$message({
                message: err,
                type: 'warning'
              });
        })
      }
      if(ccfs == 'xn'){
        that.$confirm("确定提交作品去校内查重吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.itemedit.paperguid = "正在检测..."
          that.$set(that.itemlist, that.itemeditindex, that.itemedit)    
          that.dialogFormWeekVisible1=false
          that.GetData('CCXNPapersubmit',{zwid:that.itemedit.ZWID},function(res){
            console.log(res)
            if(!res.data.paperid){        
              that.getlist();
            }
          },function(err){
            that.$message({
              message: err,
              type: 'warning'
            });
          })
        }).catch(()=>{})

      }
    },
    ccstate(item, index,ccfs){
      let that = this
      that.itemedit = item;
      that.itemeditindex = index;
      if(ccfs == 'wp')
      if(item.paperid){
        that.GetData('CCPaperList', { paperids: item.paperid }, function (res) {
          if(res.data.data == '2'){
            that.getlist();
          }else{
            that.$alert(res.data.message, '提示', {
              dangerouslyUseHTMLString: true
            });
            if(res.data.data == '3')
              that.getlist();
          }        

        }, function (err) {
          that.$message({
                message: err,
                type: 'warning'
              });
        })
      }
      if(ccfs == 'xn')
      if(item.dataid){
        that.GetData('CCPaperXNList', { dataid: item.dataid }, function (res) {
          if(res.data.data == '2'){
            that.getlist();
          }else{
            that.$alert(res.data.message, '提示（校内）', {
              dangerouslyUseHTMLString: true
            });
            if(res.data.data == '3')
              that.getlist();
          }
        }, function (err) {
          that.$message({
                message: err+'（校内）',
                type: 'warning'
              });
        })
      }
    },
    ccsummit(){
      let that = this
      this.$confirm("确定提交作品去维普查重吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.cc +=1;
          that.itemedit.paperguid = "正在检测..."
          that.$set(that.itemlist, that.itemeditindex, that.itemedit)    
          that.dialogFormWeekVisible1=false
          that.GetData('CCPapersubmit',{zwid:that.itemedit.ZWID},function(res){
            console.log(res)
            if(!res.data.paperid){        
              that.getlist();
            }
          },function(err){
            that.$message({
              message: err,
              type: 'warning'
            });
          })
        }).catch(()=>{})
    },
    addweek(){
      this.addflag = true
      this.weeklog = {LOGID:'',SSID:this.CU.cu.uid,SID:this.CU.cu.sid,ZJCLASS:'周志',LOGTYPE:'',LOGCONTENT:'',UID:this.CU.cu.uid,UNAME:this.CU.cu.uname,UCLASS:this.CU.cu.uclass}
      this.dialogFormWeekVisible = true
    },
    editweek(item,index){
      this.addflag = false
      this.weeklogIndex = index
      this.weeklog = Object.assign({}, item)
      this.dialogFormWeekVisible = true
    },
    delweek(item,index){
      const that = this
      that.$confirm("确定要删除当前周志吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.PostData('Common/DEL', {
          objname: 'zj_works_log',
          model: item
        }, res => {
          console.log(res.data)
          that.weekloglist.splice(this.weeklogIndex, 1)
        }, err => {

        })
      }).catch(() => {});
    },
    postweek(){
      const that = this
      if (!that.weeklog.LOGCONTENT) {
        this.$message({
          message: '周志不能为空',
          type: 'warning'
        });
        return false;
      }
      let par = {
        objname: 'zj_works_log',
        model: Object.assign({}, that.weeklog)
      }
      if (that.addflag) { //判断是否为新增
        that.PostData('/Common/ADD', par, res => {
          console.log(res)
          if (res.data.error_code == 0) {
            this.$message({
              message: '添加成功!',
              type: 'success'
            });
            par.model.CDATE = res.data.model.CDATE
            par.model.LOGID = res.data.model.LOGID
            that.weekloglist.push(par.model)
            that.dialogFormWeekVisible = false
          } else {
            this.$message({
              message: '添加失败!',
              type: 'warning'
            });
          }
        }, err => {
          console.log(err)
        })
      } else {
        that.PostData('/Common/EDIT', par, res => {
          if (res.data.error_code == 0) {
            that.$message({
              message: '编辑成功！',
              type: 'success'
            });
            that.$set(that.weekloglist, that.weeklogIndex, par.model)
            that.dialogFormWeekVisible = false
          } else {
            that.$message({
              message: '编辑失败！' + res.data.message,
              type: 'warning'
            });
          }
        }, err => {
          console.log(err)
        })
      }
    },
    getstudent() {
      const that = this
      let pars = {
        objname: "sys_student",
        wheres: [{
          field: 'SSID',
          sym: '=',
          val: that.CU.cu.uid,
          oper: ''
        }]
      }
      that.PostData("Common/GETLIST", pars,
        function (res) {
          if (res.data.data.length > 0)
            that.SS = res.data.data[0]
          //that.loglist = res.data.data;
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    getweeklogs(){
      const that = this
      let pars = {
        objname: "zj_works_log",
        wheres: [{
          field: 'SSID',
          sym: '=',
          val: that.CU.cu.uid,
          oper: 'and'
        },{
          field: 'ZJCLASS',
          sym: '=',
          val: '周志',
          oper: ''
        }]
      }
      that.PostData("Common/GETLIST", pars,
        function (res) {
          that.weekloglist = res.data.data;
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    getlogs() {
      const that = this
      let pars = {
        objname: "zj_works_log",
        wheres: [{
          field: 'SSID',
          sym: '=',
          val: that.CU.cu.uid,
          oper: 'and'
        },{
          field: 'ZJCLASS',
          sym: '<>',
          val: '周志',
          oper: ''
        }],
        PageSize:500,
        CurrentPage:1
      }
      that.PostData("Common/GETLIST", pars,
        function (res) {
          that.loglist = res.data.data;
          that.changecheckbox();
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    getlist() {
      const that = this
      that.PostData(
        "Common/GetOtherMethod", {
          "methodname": "GetWorksList",
          "pars": {
            "SSID": that.CU.cu.uid
          }
        },
        function (res) {
          that.itemlist = res.data.data
        },
        function (err) {
          console.log(err)
        }
      )
    },
    chkdata(callback, errback) {
      let zwcount = 0;
      let that = this
      this.itemlist.forEach(item => {
        item.children.forEach(citem => {
          if (!citem.FILEPATH)
            zwcount++
        })
      })      
      if (zwcount > 0) {
        errback("还有未上传的文件！");
      } else if (this.itemlist.length <2){//= this.pars.ZJS.length) {
        errback("还未上传内容，请先上传所有要求的文件类型后再提交！");
      } else if(that.SS.SSSTATE == '已通过'){
        errback("导师已经审阅通过，请不要重复提交！");
      } else {
        that.PostData(
          "Common/UPDATE", {
            objname: "sys_student",
            keyfield:"SSID",
            keyvalue:that.SS.SSID,
            fields:{
              SSSTATE: '已完成'
            }
          },
          function (res) {
            if (res.data.error_code != 0) {
              that.$alert(res.data.message, {
                title: "错误"
              });
              return;
            }
            that.SS.SSSTATE = "已完成"
            callback("");
          },
          function (err) {
            console.log(err);
          }
        );

      }
    },
  }
}
</script>

<style scoped>
.send {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.bcontent {
  text-align: left;
  font-size: 12px;
  line-height: 25px;
}
.el-checkbox{
  color: #606266;
    font-weight: 500;
    font-size: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-right: 5px;
}
</style>
